import { render } from "./SideMainContent.vue?vue&type=template&id=5c09ccd5&lang=html"
import script from "./SideMainContent.vue?vue&type=script&lang=js"
export * from "./SideMainContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__